import ApiLibrary from "./ApiLibrary";

class Notification extends ApiLibrary.Base {
  static className = "Notification";

  static define() {
    /* ... */
  }
}

export default ApiLibrary.createResource(Notification);
